export const calculateGradualTierPrice = (tiers: { amount: number, upTo: number | null }[], units: number) => {
  let totalCost = 0;
  let remainingUnits = units;
  let previousUpTo = 0; // Keep track of the previous tier's upper limit

  for (const tier of tiers) {
    if (remainingUnits <= 0) break;

    // Calculate the effective units for this tier
    const tierUnits = tier.upTo !== null ? Math.min(remainingUnits, tier.upTo - previousUpTo) : remainingUnits;
    totalCost += tierUnits * tier.amount;
    remainingUnits -= tierUnits;
    previousUpTo = tier.upTo ?? previousUpTo + tierUnits; // Update previousUpTo for the next iteration

    if (tier.upTo !== null && remainingUnits <= 0) break; // Exit if we've allocated all units or reached an unlimited tier
  }

  return totalCost;
};